/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PregnancyVaccine from './pregnancy-vaccine';
import PregnancyVaccineDetail from './pregnancy-vaccine-detail';
import PregnancyVaccineUpdate from './pregnancy-vaccine-update';
import PregnancyVaccineDeleteDialog from './pregnancy-vaccine-delete-dialog';

const PregnancyVaccineRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PregnancyVaccine />} />
    <Route path="new" element={<PregnancyVaccineUpdate />} />
    <Route path=":id">
      <Route index element={<PregnancyVaccineDetail />} />
      <Route path="edit" element={<PregnancyVaccineUpdate />} />
      <Route path="delete" element={<PregnancyVaccineDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PregnancyVaccineRoutes;
